import { format, unwrapFunctionStore } from 'svelte-i18n';

import { campaignsSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT, GLOBAL_LOADER_STEP } from '@client/enums';

import { cloneMenuOptions, cloneViaCampaignManager } from '../clone/clone-campaign-manager';
import { cloneEditViewOptions, cloneViaEditView } from '../clone/clone-edit-view';
import { cloningCampaign } from '../clone/cloning-campaign';
import {
  adModal,
  adModalClickAction,
  adModalTypeImage,
  adModalTypeText,
  adModalUTM,
  adModalUTMRemove,
  goToTargetingModal
} from '../create/ad-modal';
import {
  campaignModal,
  campaignModalCategories,
  campaignModalFolders,
  campaignModalName,
  campaignModalSchedule,
  campaignModalScheduleDates,
  campaignModalTags,
  goToAdModal
} from '../create/campaign-modal';
import { clickNewCampaign } from '../create/click-new-campaign';
import { creatingCampaign } from '../create/creating-campaign';
import {
  clickCreateCampaign,
  targetingModal,
  targetingModalDomain,
  targetingModalRecipient
} from '../create/targeting-modal';
import { accessingCampaignEditor, editMenuOptions } from '../edit/accessing-campaign-editor';
import { adDetails, campaignDetails, targetingDetails } from '../edit/details';
import { editingCampaign } from '../edit/editing-campaign';
import { insightsSection } from '../edit/insights';
import {
  metricsClicks,
  metricsCTR,
  metricsCTRR,
  metricsDeliveries,
  metricsGranularity,
  metricsImpressions,
  metricsReach,
  metricsWrapper
} from '../edit/metrics';
import { saveCampaign } from '../edit/save';
import {
  dashboardActions,
  dashboardCampaign,
  dashboardCreative,
  dashboardHeader,
  dashboardPerformance,
  dashboardRow,
  dashboardStatus
} from '../overview/dashboard';
import { exporting } from '../overview/export';
import { filters } from '../overview/filters';
import { layoutControls } from '../overview/layout';
import { campaignsOverview } from '../overview/overview';

const $format = unwrapFunctionStore(format);

let fullSteps = [
  campaignsOverview,
  filters,
  exporting,
  layoutControls,
  dashboardHeader,
  dashboardRow,
  dashboardCreative,
  dashboardCampaign,
  dashboardPerformance,
  dashboardStatus,
  dashboardActions,
  creatingCampaign,
  clickNewCampaign,
  campaignModal,
  campaignModalName,
  campaignModalSchedule,
  campaignModalScheduleDates,
  campaignModalTags,
  campaignModalCategories,
  campaignModalFolders,
  goToAdModal,
  adModal,
  adModalClickAction,
  adModalUTM,
  adModalUTMRemove,
  adModalTypeText,
  adModalTypeImage,
  goToTargetingModal,
  targetingModal,
  targetingModalRecipient,
  targetingModalDomain,
  clickCreateCampaign,
  cloningCampaign,
  cloneViaCampaignManager,
  cloneMenuOptions,
  cloneViaEditView,
  GLOBAL_LOADER_STEP,
  cloneEditViewOptions,
  GLOBAL_LOADER_STEP,
  editingCampaign,
  accessingCampaignEditor,
  editMenuOptions,
  GLOBAL_LOADER_STEP,
  metricsWrapper,
  metricsGranularity,
  metricsDeliveries,
  metricsImpressions,
  metricsClicks,
  metricsReach,
  metricsCTR,
  metricsCTRR,
  campaignDetails,
  adDetails,
  targetingDetails,
  insightsSection,
  saveCampaign
];

fullSteps[10] = {
  ...fullSteps[10],
  popover: {
    ...fullSteps[10].popover,
    nextBtnText: "Next <i class='os-icon-arrow-right'></i> Create Campaign Tour",
    onNextClick: () => {
      campaignsSettingsStore.subscribe((campaigns) => {
        campaigns.tours.overviewHasToured = true;
      })();

      GLOBAL_DRIVER_OBJECT.moveNext();
    }
  }
};

fullSteps[11] = {
  ...fullSteps[11],
  popover: {
    ...fullSteps[11].popover,
    showButtons: ['next']
  }
};

fullSteps[18] = {
  ...fullSteps[18],
  popover: {
    ...fullSteps[18].popover,
    onNextClick: () => {
      const folderSection = document.querySelector('#folder-section-campaigns-modal');

      if (folderSection) {
        GLOBAL_DRIVER_OBJECT.moveNext();
      } else {
        GLOBAL_DRIVER_OBJECT.moveTo(20);
      }
    }
  }
};

fullSteps[20] = {
  ...fullSteps[20],
  popover: {
    ...fullSteps[20].popover,
    onPrevClick: () => {
      const folderSection = document.querySelector('#folder-section-campaigns-modal');

      if (folderSection) {
        GLOBAL_DRIVER_OBJECT.movePrevious();
      } else {
        GLOBAL_DRIVER_OBJECT.moveTo(18);
      }
    }
  }
};

fullSteps[31] = {
  ...fullSteps[31],
  popover: {
    ...fullSteps[31].popover,
    nextBtnText: "Next <i class='os-icon-arrow-right'></i> Cloning Tour",
    onNextClick: () => {
      const closeButton = document.querySelector('.close');

      campaignsSettingsStore.subscribe((campaigns) => {
        campaigns.tours.createHasToured = true;
      })();

      if (closeButton) {
        closeButton.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

fullSteps[32] = {
  ...fullSteps[32],
  popover: {
    ...fullSteps[32].popover,
    showButtons: ['next']
  }
};

fullSteps[36] = {
  ...fullSteps[36],
  popover: {
    ...fullSteps[36].popover,
    title: 'Loading campaign...'
  }
};

fullSteps[37] = {
  ...fullSteps[37],
  popover: {
    ...fullSteps[37].popover,

    onPopoverRender: () => {
      const actionsBtn = document.querySelector('div.col-4.col-sm-6.col-md-6.text-right > span > div > button');

      if (actionsBtn) {
        actionsBtn.click();

        GLOBAL_DRIVER_OBJECT.highlight({
          element:
            '#campaign-editor > div.page-header > div > div.flex-align--center.row > div.col-4.col-sm-6.col-md-6.text-right > span > div > ul',
          popover: {
            title: 'Cloning via campaign editor',
            description:
              'To clone a campaign from the Campaign Editor page, click the <strong>&quot;Actions&quot;</strong> menu and choose <strong>&quot;Clone&quot;</strong> from the dropdown options.',
            side: 'left',
            align: 'start',
            showButtons: ['next'],
            nextBtnText: "Next <i class='os-icon-arrow-right'></i> Editing Tour",
            onNextClick: () => {
              const closeBtn = document.querySelector(
                '#campaign-editor > div.page-header > div > div.flex-align--center.row > div.col-4.col-sm-6.col-md-6.text-right > button.hide--mobile.me-2.btn.btn-secondary'
              );

              campaignsSettingsStore.subscribe((campaigns) => {
                campaigns.tours.cloneHasToured = true;
              })();

              if (closeBtn) {
                closeBtn.click();

                GLOBAL_DRIVER_OBJECT.moveNext();
              }
            }
          }
        });
      }
    }
  }
};

fullSteps[38] = {
  ...fullSteps[38],
  popover: {
    ...fullSteps[38].popover,
    title: 'Loading manager...'
  }
};

fullSteps[39] = {
  ...fullSteps[39],
  popover: {
    ...fullSteps[39].popover,
    showButtons: ['next']
  }
};

fullSteps[42] = {
  ...fullSteps[42],
  popover: {
    ...fullSteps[42].popover,
    title: 'Loading campaign...'
  }
};

fullSteps[55] = {
  ...fullSteps[55],
  popover: {
    ...fullSteps[55].popover,
    onNextClick: () => {
      const closeBtn = document.querySelector(
        '#campaign-editor > div.page-header > div > div.flex-align--center.row > div.col-4.col-sm-6.col-md-6.text-right > button.hide--mobile.me-2.btn.btn-secondary'
      );
      campaignsSettingsStore.subscribe((campaigns) => {
        campaigns.tours = {
          ...campaigns.tours,
          hasToured: true,
          editHasToured: true
        };
      })();

      if (closeBtn) {
        closeBtn.click();

        GLOBAL_DRIVER_OBJECT.destroy();
      }
    }
  }
};

export const FULL_STEPS = fullSteps;
